/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { createAction } from '../../modules/app/createAction';
import {
    TWizardExpensesDetailCheckValidationAction,
    TWizardExpensesDetailHandleNextAction,
    TWizardExpensesDetailSetParamsAction,
    TWizardExpensesDetailSetParamsPayload,
    TWizardExpensesDetailUpdateDataAction,
    TWizardExpensesDetailUpdateDataPayload,
    TWizardExpensesDetailValidationAction,
} from './types/wizardExpensesDetailActionTypes';
import { IWizardExpensesDetailValidation } from './types/wizardExpensesDetailTypes';
import {
    WIZARD_EXPENSES_DETAIL_CHECK_VALIDATION,
    WIZARD_EXPENSES_DETAIL_HANDLE_NEXT,
    WIZARD_EXPENSES_DETAIL_SET_PARAMS,
    WIZARD_EXPENSES_DETAIL_UPDATE_DATA,
    WIZARD_EXPENSES_DETAIL_VALIDATION,
} from './wizardExpensesDetailConstant';

/*
* -------------------------------------------
*         Common Wizard Actions
* -------------------------------------------
*/

export const wizardExpensesDetailHandleNextAction = (): TWizardExpensesDetailHandleNextAction =>
    createAction(WIZARD_EXPENSES_DETAIL_HANDLE_NEXT);

export const wizardExpensesDetailSetParamsAction = (payload: TWizardExpensesDetailSetParamsPayload):
    TWizardExpensesDetailSetParamsAction =>
    createAction(WIZARD_EXPENSES_DETAIL_SET_PARAMS, payload);

export const wizardExpensesDetailUpdateDataAction = (payload: TWizardExpensesDetailUpdateDataPayload):
    TWizardExpensesDetailUpdateDataAction =>
    createAction(WIZARD_EXPENSES_DETAIL_UPDATE_DATA, payload);

export const wizardExpensesDetailValidationAction = (payload: IWizardExpensesDetailValidation):
    TWizardExpensesDetailValidationAction =>
    createAction(WIZARD_EXPENSES_DETAIL_VALIDATION, payload);

export const wizardExpensesDetailCheckValidationAction = (): TWizardExpensesDetailCheckValidationAction =>
    createAction(WIZARD_EXPENSES_DETAIL_CHECK_VALIDATION);
